// ad not found page
import { Link } from 'react-router-dom'
import Layout from '../../components/Layout/Layout'

function NotFound () {
  return (
    <Layout>
      <div className=' w-full h-full bg-color2'>
        <div className=' w-full mt-8 flex flex-col items-center justify-center'>
          <h1 className=' text-2xl text-color8 font-bold mt-32'>
            This module is currently under development. Stay tuned for updates
            coming soon!
          </h1>

          <Link
            to='/home'
            className=' text-center text-xl font-bold text-color5 border-2 px-4 py-1 rounded-md mt-10'
          >
            Home
          </Link>
        </div>
      </div>
    </Layout>
  )
}

export default NotFound
